const DIRECTORY_TREATIES_ROUTES = {
    path: 'directory/treaties',
    name: 'directory-treaties',
    redirect: { name: 'treaties-list' },
    component: () => import('@/views/pages/Directories/treaties/DirectoryTreatiesPage.vue'),
    children: [
        {
            path: 'list',
            name: 'treaties-list',
            meta: { transition: 'slide-left' },
            component: () => import('@/views/pages/Directories/treaties/list/DirectoryTreatiesListPage.vue')
        },
        {
            path: ':treatiesId',
            name: 'current-treaties-treaties',
            meta: { transition: 'slide-right' },
            component: () => import('@/views/pages/Directories/treaties/current/DirectoryTreatiesCurrentPage.vue'),
            children: [
                {
                    path: 'logging',
                    name: 'current-treaties',
                    component: () => import('@/views/pages/Directories/treaties/current/tabs/logging/tab.tsx')
                },
                
            ]
        }
    ]
}

export default DIRECTORY_TREATIES_ROUTES